import Cookies, { CookieGetOptions, CookieSetOptions } from "universal-cookie";

export const getCookies = (name: string, options?: CookieGetOptions) => {
  const cookies = new Cookies();
  return cookies.get(name, options);
};

export const setCookies = (
  key: string,
  value: any,
  options?: CookieSetOptions
) => {
  const cookies = new Cookies();
  cookies.set(key, value, options);
};

export function rmCookie() {
  const cookies = new Cookies();
  let date: string = Date.now().toString();
  window.localStorage.setItem("logout", date);
  cookies.remove("IDT");
  cookies.remove("IDL");
  cookies.remove("IDSTS");
  cookies.remove("menu");
}

export const emailValidate = (id: string) => {
  const errors = { msg:"" , valid: true };

  if (!id) {
    errors.msg = "이메일이 입력되지 않앗습니다.";
    errors.valid = false;
  } else if (id.search(/\s/) != -1) {
    errors.msg = "입력된 이메일에 공백이 존재합니다.";
    errors.valid = false;
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(id)) {
    errors.msg = "입력된 이메일이 유효하지 않습니다.";
    errors.valid = false;
  }
  return errors;
};
